<nz-tabset nzSize="large">
  <nz-tab [nzTitle]="todayAdd">
    <ng-template #todayAdd>
      <div>
        {{ "order.today_add" | translate: { count: todayNewOrder?.total } }}
      </div>
    </ng-template>
    <host-recent-reservation-list #todayNewOrder type="today_new_reservation"></host-recent-reservation-list>
    <!-- <div class="tab-container">
      <host-today-add
        [todayAddList]="todayAddList"
        [todayAddTotal]="todayAddTotal"
        [channels]="channels"
        [currentLang]="currentLang"
        (refreshModal)="refresh($event)"
        (pageChanged)="pageChanged(0, $event)"
      ></host-today-add>
    </div> -->
  </nz-tab>
  <nz-tab [nzTitle]="checkIn">
    <ng-template #checkIn>
      <div>
        {{ "order.today_check_in" | translate: { count: todayCheckin?.total } }}
      </div>
    </ng-template>
    <host-recent-order-list #todayCheckin type="today_checkin"></host-recent-order-list>
    <!-- <div class="tab-container">
      <host-today-or-tomorrow-order-list
        [orderList]="checkInList"
        [listTotal]="checkInTotal"
        [channels]="channels"
        [currentLang]="currentLang"
        (refreshModal)="refresh($event)"
        (pageChanged)="pageChanged(1, $event)"
      ></host-today-or-tomorrow-order-list>
    </div> -->
  </nz-tab>
  <nz-tab [nzTitle]="checkOut">
    <ng-template #checkOut>
      <div>
        {{ "order.today_check_out" | translate: { count: todayCheckout?.total } }}
      </div>
    </ng-template>
    <host-recent-order-list #todayCheckout type="today_checkout"></host-recent-order-list>
    <!-- <div class="tab-container">
      <host-today-or-tomorrow-order-list
        [orderList]="checkOutList"
        [listTotal]="checkOutTotal"
        [channels]="channels"
        [currentLang]="currentLang"
        (refreshModal)="refresh($event)"
        (pageChanged)="pageChanged(2, $event)"
      ></host-today-or-tomorrow-order-list>
    </div> -->
  </nz-tab>
</nz-tabset>
